




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import IncomeReport from '@/components/reports/MonthlyIncomeReport.vue';
import ReportDate from '@/components/reports/MonthlyReportDate.vue';
import LevelMixin from '@/mixins/monthlyIncomeReport.mixin';

@Component({
  components: { 
    Title, 
    IncomeReport, 
    ReportDate 
  },
  mixins: [LevelMixin]
})
export default class MIReport extends Vue {}
